window.addEventListener('load', (e) => {
    console.log('Script de FAQS');

    // Ancho de la pantalla:
    let screenWidth = screen.width;

    // Altura de la barra de anuncios y del encabezado:
    const announcementBarHeight = document.getElementsByClassName('announcement-bar-section').offsetHeight;
    const headerHeight = document.getElementsByClassName('shopify-section-header-sticky').offsetHeight;
    const menuContainerHeight = document.querySelector('sticky-header').offsetHeight;


    // Altura total del encabezado: 
    let mainHeaderHeight = announcementBarHeight + headerHeight;

    // Enlaces del navbar:
    let frequentQuestionsNavLinks = document.querySelectorAll('#frequentQuestions .navbar .navbar__link');

    // Articulos:
    let frequentQuestionArticle = document.querySelectorAll('#frequentQuestions .article');

    // Preguntas internas - Enlaces:
    let internalQuestionLinks = document.querySelectorAll('#frequentQuestions .article .article__content .article__add-info .add-info__link');
    console.log(internalQuestionLinks);

    // Preguntas internas - Títulos
    let internalQuestionTitles = document.querySelectorAll('#frequentQuestions .article .article__content .article__main-info');
    console.log(internalQuestionTitles);


    
    console.log(menuContainerHeight);

    // Preguntas Internas 
    internalQuestionLinks.forEach(
        (e) => {                
            e.addEventListener('click', (e) => {

                let dataQuestionLink = e.target.dataset.question;                

                internalQuestionTitles.forEach(

                    (e) => {

                        let dataQuestionTitle = e.dataset.question;

                        if(dataQuestionTitle == dataQuestionLink){
                            console.log(dataQuestionLink);
                            console.log(dataQuestionTitle);

                            if(screenWidth <= 1024){ 
                                console.log('Prueba');
                                window.scrollTo({
                                    top: (e.offsetTop - 100),
                                    behavior: 'smooth'
                                });
                            }else {
                                window.scrollTo({
                                    top: (e.offsetTop - 100),
                                    behavior: 'smooth'
                                });
                            }

                        }
                    }
                );

            });
        }
    );

    internalQuestionTitles.forEach(
        (e) => {
            //console.log(e);
        }
    );

    // Preguntas Frecuentes
    frequentQuestionsNavLinks.forEach(
        (e)=> {
            e.addEventListener('click', (e) => {

                console.log(e.target);
                console.log(e.target.dataset);
                
                let dataLink = e.target.dataset.item;

                frequentQuestionArticle.forEach(

                    (e) => {

                        console.log(e);
                        let dataArticle = e.dataset.item;  
                        console.log(e.offsetHeight);
                        
                        //Mobile
                        if(dataLink == dataArticle){   
                            console.log('DATA ARTICLE');
                            console.log(dataArticle);
                             if(screenWidth <= 1024){ 
                                    window.scrollTo({
                                        top: (e.offsetTop - 100),
                                        behavior: 'smooth'
                                    });
                            }else {
                                window.scrollTo({
                                    top: (e.offsetTop - (menuContainerHeight + 20)),
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }
                );
            }); 
        }
    );

    frequentQuestionArticle.forEach( 
        (e)=> {
            let goTopButton = e.querySelector('.article__title .actions');

            goTopButton.addEventListener('click', () => {
                let navBar = document.getElementById('frequentQuestions');
                // Mobile
                if(screenWidth <= 1024){ 
                    window.scrollTo({
                        top: 420, 
                        behavior: 'smooth'
                    });
                }else {
                    window.scrollTo({
                        top: 0, 
                        behavior: 'smooth'
                    });
                }
            })
        }
    );

});




    // let articleTitles = document.getElementsByClassName('article__title');
    // let articlesContents = document.getElementsByClassName('article__content');

    // for(let i=0; i<articleTitles.length; i++){

    //     console.log(articlesContents[i]);
    //     articleTitles[i].addEventListener('click', () => {
    //         articlesContents[i].classList.toggle('article__content--show');

    //     });
    // }


